var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ControlGroup',[_vm._t("default"),(_vm.countries)?_c('Dropdown',{attrs:{"label":"Country/region","value":_vm.value,"options":[
      { label: 'World', value: 'World' },
      ..._vm.countries.map((country) => ({
        label: country.name,
        value: country.iso3,
      })),
    ]},on:{"input":_vm.handleInput}}):_vm._e(),_vm._t("after")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }